import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

const appUser = (state: RootState) => state.app;
const getAppUser = createDraftSafeSelector(appUser, (appUser) => appUser);

const getOpenedPopupModal = createDraftSafeSelector(
  appUser,
  (appUser) => appUser.popupModalOpen,
);

export { getAppUser, getOpenedPopupModal };
